const shadows = [
  'none',

  '0px 2px 4px rgba(6, 43, 82, 0.04)',

  '0 1px 3px rgba(6, 43, 82, 0.08), 0 2px 4px rgba(6, 43, 82, 0.04)',

  '0 2px 6px rgba(6, 43, 82, 0.08), 0 4px 8px rgba(6, 43, 82, 0.04)',

  '0 3px 8px rgba(6, 43, 82, 0.08), 0 5px 10px rgba(6, 43, 82, 0.04)',

  '0 4px 10px rgba(6, 43, 82, 0.10), 0 6px 12px rgba(6, 43, 82, 0.05)',

  '0 5px 12px rgba(6, 43, 82, 0.10), 0 8px 16px rgba(6, 43, 82, 0.05)',

  '0 6px 14px rgba(6, 43, 82, 0.10), 0 10px 20px rgba(6, 43, 82, 0.05)',

  '0 8px 16px rgba(6, 43, 82, 0.10), 0 12px 24px rgba(6, 43, 82, 0.06)',

  '0 0 2px rgba(6, 43, 82, 0.12), 0 12px 24px rgba(6, 43, 82, 0.08)',

  '0 8px 18px rgba(6, 43, 82, 0.12)',

  '0 10px 20px rgba(6, 43, 82, 0.12)',

  '0 12px 24px rgba(6, 43, 82, 0.14)',

  '0 14px 28px rgba(6, 43, 82, 0.14)',

  '0 16px 32px rgba(6, 43, 82, 0.16)',

  '0 18px 36px rgba(6, 43, 82, 0.16)',

  '0 20px 40px rgba(6, 43, 82, 0.18)',

  '0 22px 44px rgba(6, 43, 82, 0.18)',

  '0 24px 48px rgba(6, 43, 82, 0.20)',

  '0 26px 52px rgba(6, 43, 82, 0.20)',

  '0 28px 56px rgba(6, 43, 82, 0.22)',

  '0 30px 60px rgba(6, 43, 82, 0.22)',

  '0 32px 64px rgba(6, 43, 82, 0.24)',

  '0 34px 68px rgba(6, 43, 82, 0.24)',

  '0 36px 72px rgba(6, 43, 82, 0.25)',
];

const darkshadows = [
  'none',

  '0px 2px 4px rgba(0, 0, 0, 0.20)',

  '0 1px 3px rgba(0, 0, 0, 0.25), 0 2px 4px rgba(0, 0, 0, 0.18)',

  '0 2px 6px rgba(0, 0, 0, 0.28), 0 4px 8px rgba(0, 0, 0, 0.20)',

  '0 3px 8px rgba(0, 0, 0, 0.30), 0 5px 10px rgba(0, 0, 0, 0.22)',

  '0 4px 10px rgba(0, 0, 0, 0.32), 0 6px 12px rgba(0, 0, 0, 0.24)',

  '0 5px 12px rgba(0, 0, 0, 0.34), 0 8px 16px rgba(0, 0, 0, 0.25)',

  '0 6px 14px rgba(0, 0, 0, 0.36), 0 10px 20px rgba(0, 0, 0, 0.26)',

  '0 8px 16px rgba(0, 0, 0, 0.38), 0 12px 24px rgba(0, 0, 0, 0.28)',

  '0 0 2px rgba(0, 0, 0, 0.40), 0 12px 24px rgba(0, 0, 0, 0.30)',

  '0 8px 18px rgba(0, 0, 0, 0.40)',

  '0 10px 20px rgba(0, 0, 0, 0.42)',

  '0 12px 24px rgba(0, 0, 0, 0.44)',

  '0 14px 28px rgba(0, 0, 0, 0.46)',

  '0 16px 32px rgba(0, 0, 0, 0.48)',

  '0 18px 36px rgba(0, 0, 0, 0.50)',

  '0 20px 40px rgba(0, 0, 0, 0.52)',

  '0 22px 44px rgba(0, 0, 0, 0.54)',

  '0 24px 48px rgba(0, 0, 0, 0.56)',

  '0 26px 52px rgba(0, 0, 0, 0.58)',

  '0 28px 56px rgba(0, 0, 0, 0.60)',

  '0 30px 60px rgba(0, 0, 0, 0.62)',

  '0 32px 64px rgba(0, 0, 0, 0.64)',

  '0 34px 68px rgba(0, 0, 0, 0.66)',

  '0 36px 72px rgba(0, 0, 0, 0.68)',
];

export { shadows, darkshadows };